export const DEAL_REVENUE_CALCULATOR_FEATURE_FLAG = 'enabled-deal-revenue-calculator';
export const DEAL_REVENUE_CALCULATOR_SEARCH_PARAM = 'showRevenueDrawer';
